import { render, staticRenderFns } from "./XTextField.vue?vue&type=template&id=37ff8ea6&scoped=true"
import script from "./XTextField.vue?vue&type=script&lang=js"
export * from "./XTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff8ea6",
  null
  
)

export default component.exports